(function(){
  function initViewAll(){
    var list = document.querySelector('.pu-faq-list');
    if(!list || list.dataset.viewallDone) return;
    list.dataset.viewallDone = '1';
    var items = list.querySelectorAll('.pu-faq-item');
    if(items.length < 4) return;
    var splitIdx = -1;
    for(var i = 0; i < items.length; i++){
      var q = items[i].querySelector('.pu-faq-question');
      if(q && q.textContent.trim().toLowerCase().indexOf('how do i take') === 0){
        splitIdx = i; break;
      }
    }
    if(splitIdx === -1) splitIdx = Math.min(6, items.length - 1);
    if(splitIdx < 2) splitIdx = 2;
    var hiddenWrap = document.createElement('div');
    hiddenWrap.className = 'pu-faq-hidden-group';
    hiddenWrap.style.cssText = 'overflow:hidden;max-height:0;opacity:0;transition:max-height 0.45s cubic-bezier(0.4,0,0.2,1),opacity 0.35s ease;';
    var frag = document.createDocumentFragment();
    for(var j = splitIdx; j < items.length; j++){
      frag.appendChild(items[j]);
    }
    hiddenWrap.appendChild(frag);
    var toggleRow = document.createElement('div');
    toggleRow.className = 'pu-faq-item pu-faq-viewall-row';
    toggleRow.setAttribute('role','listitem');
    toggleRow.innerHTML = '<button class="pu-faq-viewall-btn" type="button" aria-expanded="false">' +
      '<svg class="pu-faq-viewall-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="#C6A96B" stroke-width="1.2"/><path d="M5 7L8 10L11 7" stroke="#C6A96B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="pu-faq-viewall-label">View All</span></button>';
    list.appendChild(toggleRow);
    list.appendChild(hiddenWrap);
    var btn = toggleRow.querySelector('.pu-faq-viewall-btn');
    var expanded = false;
    btn.addEventListener('click', function(){
      expanded = !expanded;
      btn.setAttribute('aria-expanded', expanded);
      if(expanded){
        hiddenWrap.style.maxHeight = hiddenWrap.scrollHeight + 'px';
        hiddenWrap.style.opacity = '1';
        toggleRow.querySelector('.pu-faq-viewall-label').textContent = 'View Less';
        toggleRow.querySelector('.pu-faq-viewall-icon').style.transform = 'rotate(180deg)';
      } else {
        hiddenWrap.style.maxHeight = '0';
        hiddenWrap.style.opacity = '0';
        toggleRow.querySelector('.pu-faq-viewall-label').textContent = 'View All';
        toggleRow.querySelector('.pu-faq-viewall-icon').style.transform = 'rotate(0deg)';
      }
    });
    hiddenWrap.addEventListener('transitionend', function(e){
      if(e.propertyName === 'max-height' && expanded){
        hiddenWrap.style.maxHeight = 'none';
      }
    });
  }
  var style = document.createElement('style');
  style.textContent = '.pu-faq-viewall-row{border-bottom:1px solid #E8E2D9}' +
    '.pu-faq-viewall-btn{display:flex;align-items:center;gap:10px;padding:22px 0;width:100%;background:none;border:none;cursor:pointer;font-family:"DM Sans",sans-serif}' +
    '.pu-faq-viewall-label{font-family:"DM Sans",sans-serif;font-size:16px;font-weight:500;color:#1F3D2B;letter-spacing:0}' +
    '.pu-faq-viewall-icon{flex-shrink:0;transition:transform 0.3s ease}' +
    '.pu-faq-viewall-btn:hover .pu-faq-viewall-label{color:#C6A96B;transition:color 0.2s ease}';
  document.head.appendChild(style);
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(initViewAll, 250); });
  } else {
    setTimeout(initViewAll, 250);
  }
})();